import { render, staticRenderFns } from "./consumableDeliveryList.vue?vue&type=template&id=623e541e&scoped=true"
import script from "./consumableDeliveryList.vue?vue&type=script&lang=js"
export * from "./consumableDeliveryList.vue?vue&type=script&lang=js"
import style0 from "./consumableDeliveryList.vue?vue&type=style&index=0&id=623e541e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e541e",
  null
  
)

export default component.exports